<svg width="321" height="178" viewBox="0 0 321 178" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 12C0 5.37258 5.37258 0 12 0H83.0889C87.5001 0 91.5556 2.42021 93.65 6.30252L97.1 12.6975C99.1944 16.5798 103.25 19 107.661 19H309C315.627 19 321 24.3726 321 31V166C321 172.627 315.627 178 309 178H12C5.37259 178 0 172.627 0 166V12Z" fill="white"/>
</svg>
